import { record } from 'aws-amplify/analytics'

export interface AnalyticEvent {
    name: string
    attributes?: Record<string, string>
    metric?: Record<string, number>
}

const isDevelopment = process.env.NODE_ENV === 'development'

export const logAnalytics = (event: AnalyticEvent) => {
    // Skip analytics in development mode
    if (isDevelopment) {
        return
    }

    try {
        record({
            name: event.name,
            metrics: event.metric,
            attributes: event.attributes,
        })
    } catch (error) {
        // Silently handle analytics errors to prevent disrupting app functionality
        // Only log in development for debugging
        if (isDevelopment) {
            console.error('Analytics error:', error)
        }
    }
}
